import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

/**
 * Optional factory that returns the current FCM device token.
 *
 * When provided, {@link AuthenticationService.logout} calls this function
 * and passes `{ device_token: token }` to the logout endpoint so the server
 * can deactivate the `StaffDeviceRegistration` row atomically with the logout
 * (issue #9598).
 *
 * Provide via `provideFcmLogoutToken()` from `@ts/notification/data-access`.
 */
export const FCM_LOGOUT_TOKEN_FN = new InjectionToken<
  () => Observable<string | null>
>('FCM_LOGOUT_TOKEN_FN');
